import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import type { ImageProps } from '@/app/components/media/image/types';
import { cn } from '@/app/utils/cn';
interface CardSharedImageProps {
  image: ImageProps;
  isHoverable: boolean;
}
export const CardSharedImage = t0 => {
  const $ = _c(7);
  const {
    image,
    isHoverable: t1
  } = t0;
  const isHoverable = t1 === undefined ? false : t1;
  const t2 = image.alt;
  const t3 = isHoverable ? "zoom" : undefined;
  let t4;
  if ($[0] !== image.className) {
    t4 = cn("mb-4", image.className);
    $[0] = image.className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== image || $[3] !== isHoverable || $[4] !== t3 || $[5] !== t4) {
    t5 = <Image {...image} alt={t2} isGroupHover={isHoverable} hoverEffect={t3} className={t4} />;
    $[2] = image;
    $[3] = isHoverable;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};